export const smartBookingMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/logistics/transport/jobs',
    label: 'Smart Booking',
    Description: 'Assistance Desk enables seamless monitoring and management of jobs, empowering agents with valuable assistance and support throughout their tasks, ensuring efficient workflows and optimal customer service.',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 2a8 8 0 0 1 8 8v1h-4v-1a4 4 0 0 0-4-4 4 4 0 0 0-4 4v1H4v-1a8 8 0 0 1 8-8zm-1 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM4 15h16v2H4v-2z" />
        </svg>

    ),

    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Bookings',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-8 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM4 8h16v2H4V8zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
                </svg>

            ),
            path: '/management/logistics/order-bookings',
            isEnabled: true,

        },
         {
            id: `coln-1-collections`,
            label: 'Shipments',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-8 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM4 8h16v2H4V8zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
                </svg>

            ),
            path: '/management/logistics/transport/shipment',
            isEnabled: true,

        },
        //  {
        //     id: `coln-1-collections`,
        //     label: 'Journey',
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <path fill="#007BFF" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-8 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM4 8h16v2H4V8zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
        //         </svg>

        //     ),
        //     path: '/management/logistics/transport/journey',
        //     isEnabled: true,

        // },
        {
            id: `coln-1-Categories`,
            label: 'Jobs',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17h-2v-2h2v2zm0-4h-2v-6h2v6zm6.36-1.68l-1.4-1.4a1.003 1.003 0 0 0-1.42 1.42l1.4 1.4a1.003 1.003 0 0 0 1.42-1.42zm-3.92 0l-1.4-1.4a1.003 1.003 0 0 0-1.42 1.42l1.4 1.4a1.003 1.003 0 0 0 1.42-1.42zM12 8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                </svg>

            ),
            path: '/management/logistics/transport/jobs',
            isEnabled: true,
        },
        {
            id: `coln-1-Categories`,
            label: 'Trips',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17h-2v-2h2v2zm0-4h-2v-6h2v6zm6.36-1.68l-1.4-1.4a1.003 1.003 0 0 0-1.42 1.42l1.4 1.4a1.003 1.003 0 0 0 1.42-1.42zm-3.92 0l-1.4-1.4a1.003 1.003 0 0 0-1.42 1.42l1.4 1.4a1.003 1.003 0 0 0 1.42-1.42zM12 8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                </svg>

            ),
            path: '/management/logistics/transport/trips',
            isEnabled: true,
        },
        {
            id: `coln-1-Categories`,
            label: 'Tasks',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M3 4h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm0 2v14h18V6H3zm2.707 2.293a1 1 0 0 1 1.414 0L8 10.586l3.879-3.88a1 1 0 0 1 1.414 1.414L9 12.414l-2.707-2.707a1 1 0 0 1 0-1.414zm0 4a1 1 0 0 1 1.414 0L8 14.586l3.879-3.88a1 1 0 0 1 1.414 1.414L9 16.414l-2.707-2.707a1 1 0 0 1 0-1.414z" />
                </svg>

            ),
            path: '/management/logistics/transport/tasks',
            isEnabled: true,
        },
    ],
}
)
